(function() {
  function initLoupe() {
    var containers = document.querySelectorAll('.resultats__image-container--loupe');
    containers.forEach(function(container) {
      var img = container.querySelector('.resultats__img');
      var lens = container.querySelector('.resultats__loupe');
      if (!img || !lens) return;

      var zoom = 2.0;
      var lensSize = 110;
      var hdSrc = container.dataset.hdSrc || img.currentSrc || img.src;
      var hdReady = false;

      function ensureHd() {
        if (hdReady) return;
        var preload = new window.Image();
        preload.onload = function() {
          hdReady = true;
          lens.style.backgroundImage = 'url(' + hdSrc + ')';
        };
        preload.src = hdSrc;
      }

      container.addEventListener('mousemove', function(e) {
        var rect = container.getBoundingClientRect();
        var x = e.clientX - rect.left;
        var y = e.clientY - rect.top;

        lens.style.left = (x - lensSize / 2) + 'px';
        lens.style.top  = (y - lensSize / 2) + 'px';

        var bgX = -(x * zoom - lensSize / 2);
        var bgY = -(y * zoom - lensSize / 2);

        lens.style.backgroundSize     = (rect.width * zoom) + 'px ' + (rect.height * zoom) + 'px';
        lens.style.backgroundPosition = bgX + 'px ' + bgY + 'px';
      });

      container.addEventListener('mouseenter', function() {
        ensureHd();
        lens.style.display = 'block';
      });
      container.addEventListener('mouseleave', function() { lens.style.display = 'none'; });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initLoupe);
  } else {
    initLoupe();
  }
})();
